<div class="coupon-form-box">
  <form #couponForm="ngForm" class="coupon-form mb-0">
    <div class="input-group">
      <input
        type="text"
        [(ngModel)]="coupon"
        placeholder="{{ widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_COUPON_PLACEHOLDER, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}"
        name="coupon"
        #couponModel="ngModel"
        id="coupon"
        class="form-control cbw-input-field coupon-field"
      />
      <button
        [disabled]="!coupon || isVerifying"
        type="submit"
        class="btn btn-primary redeem-button"
        (click)="onApplyCoupon()"
      >
        {{ widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_COUPON_REDEEM_TEXT, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}
      </button>
    </div>
    @if (showEmailRequiredError || showError || showInsufficientBalanceError) {
      <div id="coupon-errors" class="coupon-errors col-md-12 mt-1" role="alert">
        @if (showEmailRequiredError) {
          {{ 'coupon_credit_card_info.coupon_email_required_error' | translate }}
        } @else if (showError) {
          {{ 'coupon_credit_card_info.invalid_coupon' | translate }}
        } @else if (showInsufficientBalanceError) {
          {{ "coupon_credit_card_info.insufficient_balance_error" | translate }}
        }
      </div>
    } @else if (showSuccessMsg) {
      <div id="coupon-success" class="coupon-success col-md-12 mt-1" role="alert">
        @if (showRemainingBalanceNote) {
          {{ 'coupon_credit_card_info.coupon_applied_remaining_balance' | translate : { currency: partner?.currency, amount: remainingBalance } }}
        } @else {
          {{ 'coupon_credit_card_info.applied_successfully' | translate }}
        }
      </div>
    }
  </form>
</div>
